import React, { useMemo } from "react";
import { useData, ADMIN_TABLE } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, STATUS_OPTIONS } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";

export default function MonitorEmployee() {
  const { adminRecords, loading } = useData();
  const { user } = useAuth();

  const monitored = useMemo(() =>
    adminRecords.filter(r => userMatchesField(r.fields?.["Supervisor"], user)),
    [adminRecords, user]
  );

  if (loading && adminRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>👁️ Monitoring Tasks</h1>
        <p>Tasks where you are set as Supervisor — {monitored.length} records</p>
      </div>
      <TaskTable 
        records={monitored} 
        tableId={ADMIN_TABLE} 
        canEdit 
        canDelete 
        emptyMsg="You are not monitoring any tasks." 
        statusOptionsOverride={STATUS_OPTIONS}
      />
    </div>
  );
}
